import React from "react";
import EnterLoginOtp from "./views/LoginEnterOtp";
import { LoginOtpContextProvider } from "./LoginOtpView";
import LoginContent from "../../../../constants/contentFile.json";

const LoginEnterOtp = () => {
  return (
    <LoginOtpContextProvider>
      <EnterLoginOtp textContents={LoginContent.loginPage} />
    </LoginOtpContextProvider>
  );
};

export default LoginEnterOtp;
